const waitFor = (test, callback) => {
    if (test()) {
        callback()
        return
    }

    const interval = setInterval(() => {
        if (test()) {
            clearInterval(interval)
            callback()
        }
    }, 10)
}

export { waitFor }
